<template>
  <div class="page-compact">
    <crm-panel :title="'合同列表'">
      <div class="page-buttons">
        <crm-button
          v-if="contractAuth.addContract && contractAuth.addContract.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="handleAdd"
        >
        </crm-button>
        <crm-button
          v-if="contractAuth.exportContract && contractAuth.exportContract.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <el-select
              placeholder="审批状态"
              clearable
              v-model="searchForm.status"
              @change="handleSearch"
            >
              <el-option
                v-for="item in statusList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              placeholder="合同类型"
              clearable
              v-model="searchForm.contractType"
              @change="handleSearch"
            >
              <el-option
                v-for="(item, index) in compactType"
                :label="item.selectname"
                :value="item.selectvalue"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              placeholder="签约形式"
              clearable
              v-model="searchForm.signingForm"
              @change="handleSearch"
            >
              <el-option
                v-for="(item, index) in signingForm"
                :label="item.selectname"
                :value="item.selectvalue"
                :key="item.selectvalue+index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-cascader
              ref="cascader"
              :options="allProductLine"
              :props="{
                value: 'id',
                label: 'name',
                children: 'productLineList',
                multiple: true,
              }"
              collapse-tags
              placeholder="产品线"
              v-model="searchForm.businessLineArr"
              clearable></el-cascader>
          </el-form-item>
          <el-form-item label="">
            <el-select
              placeholder="结算比例"
              clearable
              v-model="searchForm.settlementScale"
              @change="handleSearch"
            >
              <el-option
                v-for="(item, index) in settlementScale"
                :label="item.selectname"
                :value="item.selectvalue"
                :key="item.selectvalue+index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              placeholder="合同期限"
              clearable
              v-model="searchForm.contractDeadline"
              @change="handleSearch"
            >
              <el-option
                v-for="(item, index) in contractDeadline"
                :label="item.selectname"
                :value="item.selectvalue"
                :key="item.selectvalue+index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <crm-cascader
              :value="searchForm.teamIds"
              :options="visitTeamList"
              placeholder="团队"
              clearable
              :props="{ multiple: true, checkStrictly: true }"
              :show-all-levels="false"
              @change="changeParentTeam"
            >
            </crm-cascader>
          </el-form-item>
          <el-form-item label="">
            <div class="select-data-picker">
              <el-select v-model="searchDateType">
                <el-option label="签订日期" :value="1"></el-option>
                <el-option label="合同开始日期" :value="2"></el-option>
                <el-option label="合同结束日期" :value="3"></el-option>
                <el-option label="申请日期" :value="4"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="searchTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-input
              :placeholder="`根据${searchNamePlaceholder[searchNameType]}查询`"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <el-option label="合同编号" value="contractNo"></el-option>
                <el-option label="合同名称" value="contractName"></el-option>
                <el-option label="客户名称" value="customerName"></el-option>
                <el-option label="合同创建人" value="creator"></el-option>
                <el-option label="业务员" value="salesmanName"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 合同列表 -->
      <el-table
        :data="compactData && compactData.results"
        height="100%"
        v-loading="loading"
        border
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          label="合同编号"
          width="160"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCompactDetailShow(scope)">{{
              scope.row.contractNo
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractName" fixed="left" width="130" align="center" label="合同名称" show-overflow-tooltip></el-table-column>
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          width="180"
          label="客户名称"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCustomClick(scope)">{{
              scope.row.customerName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="businessName"
          fixed="left"
          width="150"
          align="center"
          label="商机名称"
        >
          <template slot-scope="scope">
            <span
              class="link busi-name"
              @click.stop="handleBusiDetailShow(scope)"
            >
              {{ scope.row.businessName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="contractTypeName"
          width="110"
          align="center"
          label="合同类型"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="businessLineName"
          align="center"
          label="产品线"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="modeTypeName"
          align="center"
          width="130"
          label="合作模式"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="contractAmount"
          width="110"
          align="center"
          label="合同金额(元)"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="settlementName"
          width="100"
          align="center"
          label="结算方式"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="settlementScaleName"
          width="110"
          align="center"
          label="结算比例"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="signingFormName"
          width="110"
          align="center"
          label="签约形式"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="signDate"
          width="100"
          align="center"
          label="签订日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="startDateStr"
          width="100"
          align="center"
          label="合同开始日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="endDateStr"
          width="100"
          align="center"
          label="合同结束日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="myContractConfirmationName"
          width="100"
          align="center"
          label="我方签约主体"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="contractRequestNo"
          width="120"
          align="center"
          label="合同审批流水号"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="contractDeadlineName"
          width="100"
          align="center"
          label="合同期限"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="remarks"
          width="100"
          align="center"
          label="备注"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="status"
          width="90"
          align="center"
          label="审批状态"
        >
          <template slot-scope="scope">
            <span
              class="link busi-name"
              @click.stop="handleOpenOADetail(scope)"
            >
              {{ scope.row.status }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="refundAmount"
          width="110"
          align="center"
          label="已收款金额(元)"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCompactDetailShow(scope, 'returnRecord')">{{
                scope.row.refundAmount
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="invoiceAmount"
          width="120"
          align="center"
          label="已开票金额(元)"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="waitRefundAmount"
          width="110"
          align="center"
          label="未收款金额(元)"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="salesmanName"
          align="center"
          width="70"
          label="业务员"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="teamName"
          align="center"
          width="120"
          label="业务员所属团队"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="gmtModifiedStr"
          align="center"
          width="150"
          label="更新时间"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="createdName"
          align="center"
          width="70"
          label="申请人"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="gmtCreatedStr"
          align="center"
          width="150"
          label="申请日期"
        >
        </el-table-column>
        <el-table-column width="120" align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button
              v-if="
               customAuth.customerUpdateSalesman &&
                  customAuth.customerUpdateSalesman.toggleStatus
              "
              @click="handleShowChangeSalesman(row)"
              type="text"
              size="small"
            >
              替换业务员
            </el-button>
            <el-button
              @click="handleDeleteCompact(row)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 合同列表分页 -->
      <div class="pageination">
        <div class="info-wrap">
          <p>
            <span class="info-title">合同总金额(元)：</span>
            <span class="info-detail">{{ compactCount.contractAmountCount }}</span>
            <span class="info-title">合同总数：</span>
            <span class="info-detail">{{ compactCount.contractCount }}</span>
          </p>
          <p>
            <span class="info-title">已收款金额(元)：</span>
            <span class="info-detail">{{ compactCount.refundAmountCount }}</span>
            <span class="info-title">未收款金额(元)：</span>
            <span class="info-detail">{{ compactCount.waitRefundAmountCount }}</span>
          </p>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next"
          :total="(compactData && compactData.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 合同详情侧面板 -->
    <transition name="slide-fade">
      <div v-show="compactDetailVisible">
        <compact-detail
          :row="row"
          :detailId="detailId"
          :detailTabName="detailTabName"
          @handleCloseDetail="handleCloseCompactDetail"
        >
        </compact-detail>
      </div>
    </transition>

    <!-- 商机详情面板 -->
    <busi-detail
      :nextButtonState="nextButtonState"
      v-show="busiDetailVisible"
      :detailId="detailId"
      :businessId="businessId"
      :isShangJi="true"
      @handleCloseBusiDetail="handleCloseBusiDetail"
    >
    </busi-detail>

    <!-- 客户详情侧面板 -->
    <we-custom-details
      v-if="customDetailShow"
      v-bind="viewPanel"
      :sourcePart="'customer'"
      @closeCustomDetail="closeCustomDetail"
      @saveEditCustom="handleSearch"
      @success="handleRefreshCompact()"
    >
    </we-custom-details>

    <!-- 业务员修改对话框 -->
    <el-dialog
      :title="dialogUpdateSalesman.title"
      width="30%"
      @close="handleCloseSalesman()"
      :visible.sync="dialogUpdateSalesman.visible"
    >
      <el-form :model="updateSalesmanForm" label-width="120px" ref="updateSalesmanForm">
        <el-form-item
          label="当前业务员:"
          prop="code"
          :rules="{
            required: true,
            message: '请选择当前业务员',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="updateSalesmanForm.code"
            placeholder="请选择新业务员"
            v-if="dialogUpdateSalesman.isBatch"
          >
            <el-option
              v-for="item in salesmanList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
          <el-select
            filterable
            v-model="updateSalesmanForm.code"
            placeholder="请选择当前业务员"
            v-else
          >
            <el-option
              v-for="item in currrntSalesmanList"
              :label="item.salesmanName"
              :value="item.salesmanCode"
              :key="item.salesmanCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="替换后业务员:"
          prop="newCode"
          :rules="{
            required: true,
            message: '请选择替换后业务员',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="updateSalesmanForm.newCode"
            placeholder="请选择替换后业务员"
          >
            <el-option
              v-for="item in customSalesman.results"
              :label="item.salesmanName"
              :value="item.salesmanCode"
              :key="item.salesmanCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCloseSalesman()"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleupdateCustomSalesman()"> </crm-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import config from "~config";
import { newDownloadByUrl, isEmptyObj } from "@/scripts/utils";
import CompactDetail from "./component";
import WeCustomDetails from "~component/business/custom/customDetails.vue";
import crmPanel from "@/components/base/crmPanel";
import crmButton from "@/components/base/crmButton";
import AddEditDialog from "@/components/base/addEditDialog";
import CrmCascader from "@/components/base/crmCascader";
import api from "@/services/api/compact/index.js";
import service from "@/services/api/common";
import projectService from "@/services/api/project";
import BusiDetail from "~component/business/busiopportunity/busiDetail";
import { Loading } from 'element-ui'

export default {
  provide() {
    return { info: this.info };
  },
  components: {
    CompactDetail,
    WeCustomDetails,
    crmPanel,
    crmButton,
    AddEditDialog,
    CrmCascader,
    BusiDetail,
  },
  data() {
    return {
      row: {},
      loading: false,
      searchName: "",
      searchTime: [],
      searchDateType: 1,
      searchNameType: "contractNo",
      // 搜索表单
      searchDate: {
        contractStartDate: null,
        contractEndDate: null,
        createdStartDate: null,
        createdEndDate: null,
        signStartDate: null,
        signEndDate: null,
      },
      searchForm: {
        status: "",
        contractType: "",
        signingForm: "",
        businessLine: [],
        businessLineArr: [],
        teamIds: null,
        settlementScale: null,
        departmentId: null,
        customerName: null,
        salesmanName: null,
        contractNo: null,
        remarks: null,
        contractDeadline: null,
      },
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      isExportDisabled: false,
      // 合同详情
      detailTabName: null,
      detailId: "",
      businessId: "",
      compactDetailVisible: false,
      // 查看客户详情
      customDetailShow: false,
      // 客户查看面板
      customRow: {},
      viewPanel: {
        uid: "",
        type: 1,
        teamId: 1,
        authEdit: true,
        authDelete: true,
      },
      compactId: "",
      contractType: "",
      contractNumber: null,
      contractAmount: null,
      allProductLine: [], // 新版产品线
      statusList: [
        {label: '审批中', value: 0},
        {label: '已归档', value: 1},
      ], // 审批状态
      compactType: [], // 合同类型
      signingForm: [], // 签约形式
      settlementScale: [], // 结算比例
      contractDeadline: [], // 合同期限
      busiDetailVisible: false, // 商机详情
      nextButtonState: false, // 商机详情
      searchNamePlaceholder: {
        contractNo: '合同编号',
        contractName: '合同名称',
        customerName: '客户名称',
        creator: '合同创建人',
        salesmanName: '业务员',
      },
      // 业务员修改对话框
      dialogUpdateSalesman: {
        visible: false,
        title: null,
        isBatch: null,
      },
      // 业务员修改表单
      updateSalesmanForm: {
        crmSalesmans: [],
        newCode: "",
        code: "",
      },
      currrntSalesmanList: [],
    };
  },
  computed: {
    ...mapGetters({
      contractAuth: "authority/contractAuth",
      customAuth: "authority/customAuth",
      compactTeams: "compact/compactTeams",
      busiLineList: "business/busiLineList",
      compactData: "compact/compactData",
      compactDetail: "compact/compactDetail",
      crmAuth: "common/crmAuth",
      userInfo: "authority/userInfo",
      customDetail: "customer/customDetail",
      compactCount: "compact/compactCount",
      salesmanList: "common/clerkList",
      customSalesman: "customer/customSalesman",
    }),
    visitTeamList() {
      let teamArr = [];
      teamArr = JSON.parse(JSON.stringify([this.compactTeams]));
      this.deleteEmptyChild(teamArr);
      return teamArr;
    },
  },
  watch: {
    "searchForm.businessLineArr": {
      handler: "handleSearch",
    },
    "searchForm.teamIds": {
      handler: "handleSearch",
    },
    searchTime: {
      handler: "handleSearch",
    },
    searchDateType: {
      handler: "handleSearch",
    },
  },
  created() {
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.searchDateType = this.$route.params.searchDateType
        ? this.$route.params.searchDateType
        : 1;
      this.searchTime = this.$route.params.searchTime
        ? this.$route.params.searchTime
        : [];
    }
    // 获取团队
    this.getCompactTeams();
    this.searchForm.teamIds = [this.userInfo.teamId];
    if (Object.keys(this.customAuth).length === 0)
      this.getAuthority({ menuUrl: "/customer/valid" });
    this.initDict() // 初始化字典项
  },
  methods: {
    ...mapActions({
      getInsideCompactTypeList: "compactInside/getInsideCompactTypeList", // 查询字典项
      updateContractPerson: "compactInside/updateContractPerson", // 查询字典项
      getCompactCount: "compact/getCompactCount", // 合同列表数据统计
      getAuthority: "authority/getAuthority",
      getCompactTeams: "compact/getCompactTeams",
      getBusiLineList: "business/getBusiLineList",
      getCoprationDepartmentList: "compact/getCoprationDepartmentList",
      getCompactList: "compact/getCompactList",
      deleteCompact: "compact/deleteCompact",
      getCompactDetail: "compact/getCompactDetail",
      compactExport: "compact/compactExport",
      getCustomDetail: "customer/getCustomDetail",
      getBusiOpprtunityDetail: "business/getBusiOpprtunityDetail",
      getClerkList: "common/getClerkList",
      getSalesmanList: "customer/getSalesmanList",
      deleteCrmcontract: "compactInside/deleteCrmcontract", // 删除合同
    }),
    // 团队级联选择器删除空子联机
    deleteEmptyChild(arr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length <= 0) {
          delete item.children;
        } else {
          this.deleteEmptyChild(item.children);
        }
      });
    },
    changeParentTeam(teamInfo) {
      if (teamInfo.type && teamInfo.type === "multiple") {
        this.searchForm.teamIds = teamInfo.value;
      } else {
        this.searchForm.teamIds = teamInfo[teamInfo.length - 1];
      }
    },
    // 1、处理搜索数据
    handleSearchData() {
      // 组合时间参数
      this.searchDate = {
        contractStartDate: null,
        contractEndDate: null,
        createdStartDate: null,
        createdEndDate: null,
        signStartDate: null,
        signEndDate: null,
        contractEndDateStart: null,
        contractEndDateEnd: null,
      };
      const dateListStart = ["signStartDate", "contractStartDate", "contractEndDateStart", "createdStartDate", "testStartDate"];
      const dateListEnd = ["signEndDate", "contractEndDate", "contractEndDateEnd", "createdEndDate", "testEndDate"];
      if (this.searchTime && this.searchTime.length > 0) {
        this.searchDate[dateListStart[this.searchDateType - 1]] = this.searchTime[0];
        this.searchDate[dateListEnd[this.searchDateType - 1]] = this.searchTime[1];
      }
      // 组合模糊搜索参数
      const nameList = [
        "contractNo",
        "contractName",
        "customerName",
        "creator",
        "customerName",
        "salesmanName",
      ];
      nameList.forEach((i) => this.searchForm[i] = null);
      if (this.searchName) this.searchForm[this.searchNameType] = this.searchName;
    },
    // 2、新增
    async handleAdd() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打开新页面，请稍后……",
      });
      const tokenData = await projectService.getOaTokenInside();
      const flag = window.location.hostname.includes('crm.guahao-test.com')
      const oaEnv = flag ? `${window.location.protocol}//192.168.99.106:8088/spa/workflow/static4form/index.html` : `${window.location.protocol}//procurement.guahao.com/spa/workflow/static4form/index.html`
      const oaUrl = flag ? `#/main/workflow/req?iscreate=1&workflowid=49&_key=vc6ucz` : `#/main/workflow/req?iscreate=1&workflowid=173&_key=wkgn4i`
      // 默认流程中的“收支类型”为“收入类”
      if(flag){
      const OAUrl = oaEnv +
        `?ssoToken=${tokenData.data.data}${oaUrl}&field7134=${0}`;
      window.open(OAUrl);
      }else {
      const OAUrl = oaEnv +
        `?ssoToken=${tokenData.data.data}${oaUrl}&field11608=${0}`;
      window.open(OAUrl);
      }
      setTimeout(() => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      }, 2000);
    },
    // 3、分页，每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetCompactList(this.pagenation);
    },
    // 4、分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetCompactList(this.pagenation);
    },
    // 5、获取合同统计数据
    handleGetCompactCount() {
      this.handleSearchData()
      const { businessLineArr, businessLine, ...otherParams } = this.searchForm;
      return this.getCompactCount({
        ...otherParams,
        businessLine: businessLineArr.map(it => it.length >= 2 ? it[1] : '').filter(ele => !!ele),
        ...this.searchDate,
        $_priority: 10,
      })
    },
    // 6、导出按钮
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      this.handleSearchData();
      const { businessLineArr, businessLine, ...otherParams } = this.searchForm;
      const params = {
        ...this.pagenation,
        ...otherParams,
        businessLine: businessLineArr.map(it => it.length >= 2 ? it[1] : '').filter(ele => !!ele),
        ...this.searchDate,
      };
      const url = `${config.api || ""}/api/crmcontract/download`;
      newDownloadByUrl(url, "post", params).finally(() => {
        this.isExportDisabled = false;
        this.notify.close();
      });
    },
    // 7、点击审批状态，跳转到OA的审批状态页面
    async handleOpenOADetail(scope) {
      if (!scope.row.requestId) return this.$message.warning('不支持查看2022年2月前合同的审批状态');
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打开新页面，请稍后……",
      });
      const tokenData = await projectService.getOaTokenInside();
      const oaEnv = (window.location.hostname.includes('crm.guahao-test.com')) ? `${window.location.protocol}//192.168.99.106:8088/spa/workflow/static4form/index.html` : `${window.location.protocol}//procurement.guahao.com/spa/workflow/static4form/index.html`
      const OAUrl = oaEnv +
        `?ssoToken=${tokenData.data.data}#/main/workflow/req?requestid=${scope.row.requestId}`;
      window.open(OAUrl);
      setTimeout(() => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      }, 2000);
    },
    // 8、查询字典项
    initDict() {
      this.getInsideCompactTypeList({dictType: 'htlx'}).then(res => {
        this.compactType = res.data
      }).catch(e => {
        console.log(e)
      })
      this.getInsideCompactTypeList({dictType: 'qyxs'}).then(res => {
        this.signingForm = res.data
      }).catch(e => {
        console.log(e)
      })
      this.getInsideCompactTypeList({dictType: 'jsbl'}).then(res => {
        this.settlementScale = res.data
      }).catch(e => {
        console.log(e)
      })
      this.getInsideCompactTypeList({dictType: 'ztzzlx'}).then(res => {
        this.contractDeadline = res.data
      }).catch(e => {
        console.log(e)
      })
      this.getAllProductLine()
    },
    // 9、打开-商机详情
    async handleBusiDetailShow(scope) {
      await this.getBusiOpprtunityDetail({ id: scope.row.businessId })
        .then(() => {
          this.nextButtonState = true;
          this.detailId = scope.row.id;
          this.businessId = scope.row.businessId;
          this.busiDetailVisible = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 10、取消-商机详情
    handleCloseBusiDetail() {
      this.busiDetailVisible = false;
      this.nextButtonState = false;
    },
    // 11、打开-合同详情
    handleCompactDetailShow(scope, tabName) {
      this.row = scope.row;
      this.detailId = scope.row.id;
      this.contractNumber = scope.row.contractNo;
      this.contractAmount = scope.row.contractAmount;
      this.compactDetailVisible = true;
      setTimeout(() => {
        this.detailTabName = tabName || null
      }, 10)
    },
    // 12、取消-合同详情
    handleCloseCompactDetail(isRefresh) {
      this.compactDetailVisible = false;
      this.detailTabName = ''
      if (isRefresh) {
        this.handleGetCompactList();
        this.handleGetCompactCount();
      }
    },
    // 13、搜索按钮
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetCompactList();
      this.handleGetCompactCount();
    },
    // 14、根据条件刷新合同列表
    handleGetCompactList() {
      this.loading = true;
      this.handleSearchData();
      const { businessLineArr, businessLine, ...otherParams } = this.searchForm;
      this.getCompactList({
        ...this.pagenation,
        ...otherParams,
        businessLine: businessLineArr.map(it => it.length >= 2 ? it[1] : '').filter(ele => !!ele),
        ...this.searchDate,
        $_priority: 10,
      }).finally(() => {
        this.loading = false;
      });
    },
    // 15、产品线下拉
    getAllProductLine() {
      service.queryProductLineListForSearch().then((res) => {
        res.data.data.forEach((item) => {
          this.allProductLine.push({
            ...item,
            id: item.typeCode,
            name: item.typeName,
          });
        });
      });
    },

    handleRefreshCompact() {
      this.handleGetCompactList();
      this.handleGetCompactCount();
    },
    // 客户详情
    async handleCustomClick(scope) {
      if (scope.row.customerIsDeleted === 1) {
        this.$message({
          type: "error",
          message: "该客户不存在或已删除",
        });
      } else {
        await this.getCustomDetail({
          sourcePart: "customer",
          uid: scope.row.customerId,
        }).then(() => {
          if (!isEmptyObj(this.customDetail)) {
            this.customRow = scope.row;
            this.customDetailShow = true;
            this.viewPanel = Object.assign(this.viewPanel, {
              uid: scope.row.customerId,
              type: scope.row.customerType,
              teamId: scope.row.teamId,
              authEdit:
                !scope.row.searchUid && this.customAuth.customerUpdate.toggleStatus,
              authDelete: this.customAuth.customerDelete.toggleStatus,
            });
          }
        });
      }
    },
    closeCustomDetail() {
      this.customDetailShow = false;
      this.handleGetCompactList();
      this.handleGetCompactCount();
    },
    // 业务员
    handleShowChangeSalesman(row){
      if (this.salesmanList.length === 0) {
        this.getClerkList();
      }
      if (row) {
        this.getSalesmanList({
          customerUid: row.customerId,
          pageNumber: 1,
          pageSize: 100,
          sourcePart: "customer",
        });
      }
      this.updateSalesmanForm.crmSalesmans = [row.id];
      this.updateSalesmanForm.code = row.salesmanCode
      this.currrntSalesmanList = [{
        salesmanCode: row.salesmanCode,
        salesmanName: row.salesmanName,
      }]
      this.dialogUpdateSalesman = {
        visible: true,
        title: "替换业务员",
        isBatch: !row,
      };
    },
    // 取消修改业务员
    handleCloseSalesman() {
      this.dialogUpdateSalesman.visible = false;
      this.$refs.updateSalesmanForm.resetFields();
    },
    // 修改业务员
    handleupdateCustomSalesman() {
      this.$refs.updateSalesmanForm.validate().then((valid) => {
        if (valid) {
          this.updateContractPerson({
            ...this.updateSalesmanForm,
          })
            .then(() => {
              this.$message({
                message: "修改业务员成功",
                type: "success",
              });
              this.dialogUpdateSalesman.visible = false;
              return this.handleSearch();
            })
            .finally(() => {
              this.$refs.updateSalesmanForm.resetFields();
            });
        }
      });
    },
    // 删除合同
    async handleDeleteCompact(row) {
      try {
        await this.$confirm('当前操作，将把该合同从CRM中删除，并删除与商机的关联关系，是否确认？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await this.deleteCrmcontract({id: row.id})
        this.$message.success('删除成功！');
        this.handleSearch()
      }catch (e) {
        console.log(e)
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/const.less";

.page-compact {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .el-checkbox {
    color: rgba(0, 0, 0, 0);
  }

  /deep/ .el-table .el-table__fixed {
    height: auto !important;
    bottom: 17px;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
